const experiments = new Set();
export const registerExperiment = (name, supportedVariants) => {
    experiments.add({ name, supportedVariants });
};
export const getRegisteredExperiments = () => Array.from(experiments);
//# sourceMappingURL=register-experiment.js.map